var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('job-layout',{key:"post_job"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('app-name-page',{attrs:{"name":"Post a Job","color":"var(--green)"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-container',{attrs:{"fill-height":"","w--max--800":"","grid-list-xl":""}},[_c('app-job-form')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fffed15","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/app/jobs/job-post.vue
// module id = null
// module chunks = 